import user_api from '@/api/user';
import Vue from 'vue';

const state = {
    token: '',
    user: {},
    resData: {},
};

const getters = {};

const actions = {
    login({ commit }, loginInfo) {   
        user_api.login(data => {
            commit('setToken', data);        
        }, Vue.http, loginInfo.username, loginInfo.password);
    }
};

const mutations = {
    setToken(state, data) {
        state.resData = data;
        if(data.status_code == 400){
            return;
        }

        state.token = data.token;
        state.user = data.user;
        localStorage.setItem('jwt', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));  
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
